import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { BookingProvider } from "./components/BookingDialog";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import Activities from "./pages/Activities";
import ActivityDetail from "./pages/ActivityDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ConfirmDate from "./pages/ConfirmDate";
import Admin from "./pages/Admin";


const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function Shell() {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin") || pathname.startsWith("/payment") || pathname.startsWith("/confirm-date");
  return (
    <>
      <ScrollToTop />
      {!bare && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/activites" element={<Activities />} />
          <Route path="/activites/:slug" element={<ActivityDetail />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/confirm-date" element={<ConfirmDate />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      {!bare && <ChatWidget />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <BookingProvider>
            <Shell />
          </BookingProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
